import type { PermissionsContextValue } from 'src/types/permissions';

import { createContext } from 'react';

// ----------------------------------------------------------------------

export const PremissionContext = createContext<PermissionsContextValue | undefined>(undefined);

export const PermissionContext = PremissionContext;
